import { render, staticRenderFns } from "./VersionHistory.vue?vue&type=template&id=c493aac0&scoped=true&"
import script from "./VersionHistory.vue?vue&type=script&lang=ts&"
export * from "./VersionHistory.vue?vue&type=script&lang=ts&"
import style0 from "./VersionHistory.vue?vue&type=style&index=0&id=c493aac0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c493aac0",
  null
  
)

export default component.exports